// extracted by mini-css-extract-plugin
export default {"font-title":"styles_font-title__WX3MJ"};